<div class="flex-center">
  <div class="contentWidth">
    <div style="height: calc(90vh - 100px); overflow-y: auto;">
      <form [formGroup]="CSRForm" autocomplete="off">
        <ng-container formArrayName="CSRRows">
          <table #objTable
            mat-table
            matSort
            [dataSource]="dataSource"
            class="table-add-butt-header-orange mat-elevation-z8 mat-table-custom">

            <ng-container matColumnDef="headertitle">
              <th class="title-col" mat-header-cell *matHeaderCellDef colspan="4">
                <div class="pull-left">
                  <h4>JCoB Rules - Masterdata</h4>
                </div>
              </th>
            </ng-container>
            <ng-container matColumnDef="headeraddbutton">
              <th class="butt-col" mat-header-cell *matHeaderCellDef>
                <div class="OrangeButton">
                  <button mat-raised-button (click)="addNewRow()"
                    matTooltip="Add Release" class="button-color-fix pull-right">
                    <mat-icon class="icon-color-fix icon-padding-fix">add_box</mat-icon>
                  </button>
                </div>
              </th>
            </ng-container>

            <!-- RuleFileVersion Column -->
            <ng-container matColumnDef="RuleFileVersion">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="RuleFileVersion" style="width:15%">Rules file Version</th>
              <td mat-cell *matCellDef="let element" style="width:15%">
                @if (element.isEditable) {
                  <div [innerHTML]="element.ruleFileVersion"></div>
                }
                @if (!element.isEditable) {
                  <mat-form-field style="width: 100%">
                    <input matInput type="text"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="element.ruleFileVersion"
                      maxlength="30"
                      matTooltip="Max 30 characters"
                      (keydown)="checkInput($event)" />
                    </mat-form-field>
                  }
                </td>
              </ng-container>

              <!-- ManufacturingCenterProduct Column -->
              <ng-container matColumnDef="ManufacturingCenterProduct">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="ManufacturingCenterProduct" style="width:20%">Manufacturing Center Product</th>
                <td mat-cell *matCellDef="let element" style="width:25%">
                  @if (element.isEditable) {
                    <div [innerHTML]="getManufacturingCenterProductbyId(element.manufacturingCenterProductID)"></div>
                  }
                  @if (!element.isEditable) {
                    <mat-form-field floatLabel="auto">
                      <mat-select style="min-width: 200px; width: 80%; color:red" [(ngModel)]="element.manufacturingCenterProductID"
                        (ngModelChange)="onMCPChange(element)"
                        [ngModelOptions]="{standalone: true}">
                        <mat-option [value]="-1" [disabled]="true">Select</mat-option>
                        @for (fc of originalMfgCenterProduct; track fc) {
                          <mat-option [value]="fc.manufacturingCenterProductID">
                            {{fc.mfgCenter}} - {{fc.productCode}} - {{fc.productName}}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                </td>
              </ng-container>

              <!-- ControllerSoftwareVersion Column -->
              <ng-container matColumnDef="ControllerSoftwareVersion">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="ControllerSoftwareVersion" style="width:40%">
                  Controller Software Version
                </th>
                <td mat-cell *matCellDef="let element; let i = index" style="width:25%; position:relative;">
                  @if (element.isEditable) {
                    <mat-chip-set>
                      @for (version of element.controllerSoftwareVersions; track version) {
                        <mat-chip>
                          {{ version.controllerSoftwareVersion }}
                        </mat-chip>
                      }
                    </mat-chip-set>
                  } @else {
                    <mat-form-field style="width:100%; position:relative;" floatLabel="auto">
                      <mat-chip-grid #chipList>
                        @for (version of element.controllerSoftwareVersions; track version; let j = $index) {
                          <mat-chip-row
                            [removable]="true"
                            (removed)="removeControllerSoftware(element, j)">
                            {{ version.controllerSoftwareVersion }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                          </mat-chip-row>
                        }
                        <input placeholder=""
                          [matChipInputFor]="chipList"
                          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                          [matChipInputAddOnBlur]="false"
                          [matAutocomplete]="auto"
                          matAutocompleteTrigger
                          [(ngModel)]="controllerSoftwareInput[i]"
                          [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="filterControllerSoftwareOptions($event, element)"
                          (matChipInputTokenEnd)="addControllerSoftwareFromInput($event, element)"
                          (focus)="openControllerSoftwareAutocomplete(element, i)"
                          style="min-width: 80px; width: auto; flex: 1 1 80px;">
                        </mat-chip-grid>
                        <mat-icon class="search-suffix-fixed">search</mat-icon>
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedControllerSoftware($event, element)">
                          @for (option of controllerSoftwareFiltered[i]; track option) {
                            <mat-option [value]="option.controllerSoftwareVersionID">
                              {{ option.controllerSoftwareVersion }}
                            </mat-option>
                          }
                        </mat-autocomplete>
                      </mat-form-field>
                    }
                  </td>
                </ng-container>

                <!-- Software file Column -->
                <ng-container matColumnDef="file">
                  <th mat-header-cell *matHeaderCellDef style="width:10%">Rules File</th>
                  <td mat-cell *matCellDef="let element; let i = index" style="width:10%">
                    @if (element.isEditable) {
                      <div>
                        <button mat-icon-button
                          matTooltip="View"
                          color="primary"
                          (click)="openRuleFile(element.ruleFileId)">
                          <mat-icon class="actionButtons">remove_red_eye</mat-icon>
                        </button>
                      </div>
                    }
                    @if (!element.isEditable) {
                      <input type="file" accept=".xml"
                        class="form-control"
                        (change)="onFileChange($event, i)" />
                    }
                  </td>
                </ng-container>

                <!-- UseforConfigGen Column -->
                <ng-container matColumnDef="UseforConfigGen">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="UseforConfigGen" style="width:10%">Use for ConfigGeneration</th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox (change)="onCheckboxChange($event, element.ruleFileId)"
                      [checked]="element.userForConfigGeneration"
                      [disabled]="element.isEditable">
                    </mat-checkbox>
                  </td>
                </ng-container>

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef style="width:10%"></th>
                  <td mat-cell *matCellDef="let element" style="width:10%">
                    @if (!element.isEditable) {
                      <button mat-icon-button
                        matTooltip="Cancel Changes"
                        color="warn"
                        (click)="resetRowByID(element.ruleFileId)">
                        <mat-icon class="actionButtons">rotate_left</mat-icon>
                      </button>
                    }
                    @if (element.isEditable) {
                      <button mat-icon-button
                        matTooltip="Edit"
                        color="primary"
                        (click)="editRowByID(element.ruleFileId)">
                        <mat-icon class="actionButtons">edit</mat-icon>
                      </button>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="savefooter">
                  <th mat-footer-cell *matFooterCellDef colspan="6">
                    <div class="OrangeButton">
                      <button mat-raised-button type="submit" (click)="onSave()"
                        [disabled]="!anyChange()"
                        [matTooltip]="anyChange()? 'Save changes' : 'Save disabled'"
                        class="button-color-fix pull-right">
                        Save
                        <mat-icon style="color:white !important" class="icon-color-fix">save</mat-icon>
                      </button>
                    </div>
                  </th>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="['headertitle', 'headeraddbutton']; sticky: true" class="stickyTopz100"></tr>
                <tr class="col-headers" mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: columnsToDisplay;" [class.alternative2]="!row.isEditable"></tr>
                <tr mat-footer-row *matFooterRowDef="['savefooter']; sticky: true"></tr>
              </table>
            </ng-container>
          </form>
        </div>
      </div>
    </div>